import React, {forwardRef} from 'react';

interface CheckboxInputProps {
  id: string;
  label: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  tabIndex?: number;
}

const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  (
    {id, label, checked, onChange, onBlur, error, required, disabled, tabIndex},
    ref,
  ) => {
    return (
      <div className="flex flex-col items-start w-full">
        <div className="flex gap-2 w-full">
          <div className="flex w-6 items-start">
            <input
              type="checkbox"
              id={id}
              ref={ref}
              checked={checked}
              onChange={onChange}
              onBlur={onBlur}
              required={required}
              disabled={disabled}
              tabIndex={tabIndex}
              className={`h-5 w-5 rounded border focus:outline-cyan-400 transition-colors duration-150
              ${error ? 'border-red-500' : 'border-slate-200'}
              disabled:bg-slate-100 disabled:text-slate-300 disabled:border-0 disabled:pointer-events-none disabled:cursor-not-allowed
              dark:bg-transparent dark:border-neutral-700 dark:focus:ring-neutral-600`}
              aria-describedby={`${id}-error`}
              data-testid={`${id}-checkbox`}
            />
          </div>
          <label
            htmlFor={id}
            className="text-slate-800 text-sm font-semibold font-['Inter'] dark:text-white select-none">
            {label}
          </label>
        </div>
        {error && (
          <p className="text-xs text-red-600" id={`${id}-error`}>
            {error}
          </p>
        )}
      </div>
    );
  },
);

CheckboxInput.displayName = 'CheckboxInput';

export default CheckboxInput;
